<script setup lang="ts">
import { onMounted, ref } from "vue"
import { Footer, HostNavbar } from "@/components"

const isLoaded = ref(false)

onMounted(() => {
  onload = () => {
    isLoaded.value = true
  }

  setTimeout(() => {
    isLoaded.value = true
  }, 3000)
})
const hideLocaleSwitch = ref(true)
</script>

<template>
  <div>
    <transition name="gpx-fade">
      <div v-show="isLoaded" class="host-bg fixed inset-0 -z-10 bg-center bg-cover bg-no-repeat" />
    </transition>
    <header>
      <slot name="navbar">
        <HostNavbar />
      </slot>
    </header>
    <main class="relative unauthorized-layout-main">
      <div class="container my-16">
        <slot name="default" />
      </div>
      <slot name="footer">
        <Footer :hide-locale-switch="hideLocaleSwitch" />
      </slot>
    </main>
  </div>
</template>

<style scoped>
.host-bg {
  background-image: url("@/assets/host_bg.png");
}

.unauthorized-layout-main {
  min-height: calc(100dvh - var(--gpx-navbar-height));
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
</style>
